import React from 'react';

export default function Footer() {
  return (
    <footer className="border-t border-brand-border py-10 relative z-10">
      <div className="max-w-[1100px] mx-auto px-8">
        <div className="flex justify-between items-center flex-wrap gap-4">
          <div className="font-serif text-[1rem] font-medium text-brand-muted tracking-[0.04em]">
            Harald <span className="text-brand-gold3">Suekar</span> · Executive Sparringpartner · Wien
          </div>
          <ul className="flex gap-8 list-none m-0 p-0">
            {['Über', 'Struktur', 'Preise', 'Ergebnisse', 'Kontakt'].map((item, i) => (
              <li key={i}>
                <a href={`#${item.toLowerCase() === 'über' ? 'about' : item.toLowerCase() === 'preise' ? 'investition' : item.toLowerCase()}`} 
                   className="text-[0.7rem] font-medium tracking-[0.1em] uppercase text-brand-muted2 no-underline transition-colors hover:text-brand-gold">
                  {item}
                </a>
              </li>
            ))}
          </ul>
          <div className="text-[0.72rem] text-brand-muted2">
            © 2025 Harald Suekar · Wien
          </div>
        </div>
      </div>
    </footer>
  );
}